import { CommonModule } from "@angular/common";
import { Component, type OnInit } from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { SharedModule } from "primeng/api";
import { CoreCommonModule } from "../../../../utils/modules/core/modules/core-common.module";
import { RouterModule } from "@angular/router";
import { WtfAnimations } from "../../../../utils/others/core/animations";
import { RecoveryRequestService } from "../../../../services/security/recovery-request.service";

@Component({
    providers: [RecoveryRequestService],
    templateUrl: "./recovery-request.component.html",
    styleUrl: "./recovery-request.component.scss",
    animations: WtfAnimations,
})
export class RecoveryRequestComponent implements OnInit {
    public recoveryRequestForm: FormGroup;
    public isWaiting = false;
    public isRecoveryRequestSent = false;
    public userEmailNotFound = false;

    constructor(
        private formBuilder: FormBuilder,
        private recoveryRequestService: RecoveryRequestService
    ) {}

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm() {
        this.recoveryRequestForm = this.formBuilder.group({
            email: ["", [Validators.required, Validators.email]],
        });
    }

    sendRecoveryRequest() {
        this.isWaiting = true;
        this.userEmailNotFound = false;
        try {
            this.recoveryRequestService
                .sendRecoveryRequest(this.recoveryRequestForm.value.email)
                .subscribe({
                    next: (res: any) => {
                        if (res.success) {
                            this.isWaiting = false;
                            this.recoveryRequestForm.reset();
                            this.isRecoveryRequestSent = true;
                        } else {
                            this.isWaiting = false;
                        }
                    },
                    error: (error: any) => {
                        this.userEmailNotFound = true;
                        this.isWaiting = false;
                    },
                });
        } catch (error) {
            this.isWaiting = false;
        }
    }

    disableButton() {
        return this.recoveryRequestForm.invalid;
    }
}
